import * as React from 'react';
import MuiListItemSecondaryAction, {
  ListItemSecondaryActionProps,
} from '@mui/material/ListItemSecondaryAction';

const EDListItemSecondaryAction: React.FunctionComponent<
  React.PropsWithChildren<ListItemSecondaryActionProps>
> & {
  muiName?: string;
} = props => <MuiListItemSecondaryAction {...props} />;

// Need to set muiName for material ui to recognise this component as a ListItemSecondaryAction
EDListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

export default EDListItemSecondaryAction;
